import BannerCarousel from "./components/BannerCarousel"
import Footer from "../components/Footer"
import Mission from "./components/Mission"

import './style.scss'
import CompanyProfile from "./components/CompanyProfile"

const Front = props => {
    return <div className="front-page-container">
        <BannerCarousel />
        <Mission />
        <CompanyProfile />
        <Footer />
    </div>
}

export default Front
